import React, { useState } from 'react';
import { Select } from 'antd';
import clsx from 'clsx';
import './CustomSelect.module.scss'; // CSS file where custom-select-selected is defined

const { Option } = Select;

const CustomSelectWithFilter = ({
        data = [],
        placeholder = 'Select an option',
        value: externalValue, // external value prop if passed
        onChange,
        allowClear = true,
        className = '',
        style = {},
        showSearch = true,
        disabled,
}) => {
        const [internalValue, setInternalValue] = useState(undefined);

        const handleChange = (val) => {
                setInternalValue(val);
                if (onChange) onChange(val);
        };

        const finalValue = externalValue !== undefined ? externalValue : internalValue;

        const combinedClassName = clsx(className, {
                'custom-select-selected': finalValue,
        });

        return (
                <Select
                        showSearch={showSearch}
                        placeholder={placeholder}
                        allowClear={allowClear}
                        value={finalValue}
                        onChange={handleChange}
                        className={`${combinedClassName}`}
                        style={style}
                        disabled={disabled}
                        optionFilterProp="children"
                        filterOption={(input, option) => option?.children?.toLowerCase().includes(input.toLowerCase())}>
                        {data.map((item) => (
                                <Option
                                        key={item.value}
                                        value={item.value}>
                                        {item.label}
                                </Option>
                        ))}
                </Select>
        );
};

export default CustomSelectWithFilter;
